﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Suscripción",
  "change": "Cambiar",
  "currency": "USD",
  "save": "Guardar",
  "save17Percent": "<strong>Ahorre el {{percent}} %</strong> con un plan anual",
  "save17PercentNoBold": "Ahorre el {{percent}} %",
  "yearly": "Anual",
  "monthly": "Mensual",
  "Lifetime": "De por vida",
  "PerMonth": "Por mes",
  "PerYear": "Por año",
  "Free": "Libre",
  "optional": "Opcional",
  "trialLengthTrial": "<0>{{ trialLength }}</0>días de prueba",
  "viewAllPlans": "Ver todos los planes",
  "myBoardmaker": "My Boardmaker",
  "canada": "Canadá",
  "unitedStates": "Estados Unidos",
  "oneMomentPlease": "Espere un momento...",
  "software": "Software",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Completar",
  "loadingRegions": "Cargando las regiones disponibles",
  "loadingPartners": "Cargando los socios disponibles",
  "supportedPeripherals": "Periféricos compatibles",
  "pleaseWait": "Espere...",
  "minimum": "Mínimo",
  "recommended": "Recomendado",
  "browser": "Navegador",
  "tobiiDynavoxEyeTrackers": "Tobii Dynavox Eye Trackers",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "Necesito ayuda para elegir",
  "or": "o",
  "advantages": "Ventajas",
  "visitPartnerSite": "Visite el sitio de socios",
  "recentOrders": "Órdenes recientes",
  "current": "actual",
  "orLater": "o posterior",
  "customerSupport": "Atención al cliente",
  "proratedAmount": "Monto prorrateado",
  "community": {
    "community": "Comunidad",
    "getStartedNow": "¡Empiece ahora!"
  },
  "personal": "Personal",
  "professional": "Profesional",
  "planCard": {
    "noCCRequired": "No se requiere una tarjeta de crédito",
    "cCOnly": "Pago solo con tarjeta de crédito",
    "cCOrPO": "Tarjeta de crédito u orden de compra",
    "myPlan": "Mi plan",
    "currentPlan": "Plan actual",
    "downgradeNotice": "El cambio entra en vigencia una vez que expira el plan actual.",
    "upgradeNotice": "El cambio entra en vigencia de inmediato."
  },
  "selectedPlanSummary": {
    "summary": "Resumen",
    "change": "$t(change)",
    "subtotal": "Subtotal"
  },
  "action": {
    "joinToday": "¡Únase hoy!",
    "finish": "Terminar",
    "subscribe": "Suscribir",
    "resubscribe": "Suscribirse de nuevo",
    "requestAQuote": "Solicitar un presupuesto",
    "try": "Probar",
    "startTrial": "Comience la prueba",
    "buyNow": "Comprar ahora",
    "tryIt": "Pruébelo",
    "tryItFree": "¡Pruébelo gratis durante 30 días!",
    "free": "gratis",
    "getStarted": "Empezar",
    "forTrialDays": "por <1>{{trialLength}}</1> días",
    "comparePlans": "Comparar planes",
    "hideComparisons": "Ocultar las comparaciones",
    "learnMore": "Conocer más",
    "start": "Comenzar",
    "next": "Siguiente",
    "edit": "Editar",
    "cancel": "Cancelar",
    "imTaxExempt": "Exención de impuestos",
    "submit": "Enviar",
    "print": "Imprimir",
    "backToPaymentDetails": "Regresar a los detalles de pago",
    "close": "Cerrar",
    "back": "Atrás",
    "continue": "Continuar",
    "uploading": "Cargando",
    "delete": "Eliminar",
    "update": "Actualizar",
    "generatingInvoice": "Generando la factura",
    "proceed": "Proceder",
    "modify": "Modificar",
    "yes": "Yes",
    "signUp": "Registrarse",
    "downloads": "Descargar"
  },
  "status": {
    "loading": "Cargando...",
    "creatingAccount": "Creando cuenta...",
    "submitting": "Enviando...",
    "submittingPayment": "Enviando el pago...",
    "submittingRequest": "Enviando la solicitud..."
  },
  "planComparison": {
    "label": "¿Cuáles son los beneficios de las funciones de cada plan?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Comparación de las funciones",
    "subheader": "¡La solución favorita de todos para crear un sinfín de soportes visuales y de comunicación con base en símbolos!"
  },
  "account": {
    "email": "Correo electrónico",
    "accountFoundTitle": "Se encontró la cuenta.",
    "accountFoundMessage": "Ya existe una cuenta con este correo electrónico. ¿Desea iniciar sesión con esa cuenta o usar un correo electrónico diferente y crear una nueva cuenta?",
    "signedOutElsewhereTitle": "Se ha cerrado la sesión",
    "signedOutElsewhereMessage": "Se cerró su sesión en otra pestaña. Inicie sesión nuevamente para continuar, o descarte este mensaje para seguir navegando sin una cuenta.",
    "signedOutElsewhereDismiss": "Continuar navegando",
    "federatedEmailTitle": "Se detectó un correo electrónico de organización",
    "federatedEmailMessage": "Esta dirección de correo electrónico usa el inicio de sesión de su organización. Inicie sesión para acceder a Boardmaker a través de su organización o use otra dirección de correo electrónico para crear una cuenta nueva.",
    "federatedEmailUseDifferent": "Usar otro correo electrónico",
    "logIn": "Iniciar sesión",
    "logOut": "Cerrar sesión",
    "loggingIn": "Iniciando sesión...",
    "loggingOut": "Cerrando sesión...",
    "verifying": "Verificando...",
    "loggingInMessage": "Iniciando sesión...",
    "createAccount": "Crear cuenta",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Ya tengo una ",
    "login2": "cuenta de",
    "login3": "Tobii Dynavox.",
    "loginPrompt": "¿Ya tiene una <1>cuenta de Tobii Dynavox</1>? <3>Iniciar sesión</3>",
    "cancelSubscription": "Cancelar la suscripción",
    "areYouSure": "¿Está seguro de que desea seleccionar este plan? Si procede, ocurrirá lo siguiente",
    "cancelSubscriptionProcess": "Cancelar el proceso de suscripción (se perderá su progreso actual)",
    "changeToCommunityPlan": "Cambiar su cuenta a un Plan Comunitario",
    "onceYouveCompletedYourProfile": "Una vez que haya completado su perfil, si decide actualizar su plan, puede hacerlo en cualquier momento desde la sección Mi cuenta.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Recuperar la información del usuario"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Complete los detalles a continuación y un administrador de cuentas se comunicará con usted en breve.",
    "fillOutDetailsBelowLicense": "Complete los detalles a continuación y un asesor de ventas se comunicará con usted en breve."
  },
  "forms": {
    "confirmEmail": "Confirmar correo electrónico.",
    "billingDetails": "Detalles de facturación",
    "paymentType": "Tipo de pago",
    "creditCardType": "Tipo de pago",
    "creditCard": "Tarjeta de crédito",
    "purchaseOrder": "Orden de compra",
    "cardNumber": "Número de tarjeta",
    "expirationDate": "Fecha de vencimiento",
    "cardholderName": "Nombre del titular de la tarjeta",
    "cardSecurityCode": "Código de seguridad de la tarjeta",
    "securityCode": "Código de seguridad",
    "organizationName": "Nombre de la organización",
    "accountsPayableEmail": "Correo electrónico de facturación",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "addressLine": "Dirección Línea 1",
    "addressLine2": "Dirección Línea 2",
    "country": "País",
    "language": "Idioma",
    "city": "Ciudad",
    "stateProvinceRegion": "Estado/provincia/región",
    "zipPostalCode": "Código postal",
    "month": "Mes",
    "year": "Año",
    "optional": "Opcional",
    "username": "Nombre de usuario",
    "name": "Nombre",
    "phoneNumber": "Número de teléfono",
    "phone": "Teléfono",
    "email": "Correo electrónico",
    "url": "URL",
    "selectYourCountry": "Selecciona tu país",
    "selectYourState": "Seleccione su estado",
    "selectYourProvinceTerritory": "Seleccione su provincia o territorio",
    "selectYourTerm": "Seleccione su plazo",
    "1year": "1 año",
    "2years": "2 años",
    "3years": "3 años",
    "4years": "4 años",
    "5years": "5 años",
    "instructorLogins": "Número de inicios de sesión del instructor",
    "studentLogins": "Número de inicios de sesión de los estudiantes",
    "term": "Plazo",
    "tradeIn": "¿Es elegible para un descuento comercial?",
    "legacyVersions": "¿Tiene versiones heredadas de Boardmaker para cambiar por un descuento en el costo de myBoardmaker?",
    "selectAResponse": "Seleccione una respuesta",
    "yes": "Yes",
    "no": "No",
    "notSure": "No estoy seguro",
    "password": "Contraseña",
    "confirmPassword": "Confirmar contraseña",
    "additionalInformationOrQuestions": "Información adicional o preguntas",
    "countryNotSupported": "---",
    "uploadDocument": "Subir un documento",
    "chooseFile": "Seleccionar un archivo",
    "paymentMethod": "Método de pago",
    "purchaseOrdersAreOnlyProcessed": "Las órdenes de compra solo se procesan una vez que se envía su pedido, así que pueden modificarse en cualquier momento antes de eso.",
    "PONumber": "Número de la orden de compra",
    "PONotes": "Notas de organización",
    "iVerifyThatImAuthorized": "Confirmo que estoy autorizado para enviar esta orden de compra.",
    "submissionSuccessful": "¡Envío exitoso!",
    "thankYourForYourRequest": "¡Gracias por su solicitud! Un administrador de cuentas se comunicará con usted en breve.",
    "ccExpDateFormat": "MM/AAAA",
    "numberOfLicenses": "Número de licencias",
    "pleaseEnterYourName": "Ingrese su nombre exactamente como aparece en la tarjeta",
    "needHelpFindingSecurityCode": "¿Necesita ayuda para encontrar el código de seguridad de su tarjeta?"
  },
  "validation": {
    "required": "Obligatorio",
    "invalidEmail": "Correo electrónico no válido",
    "emailsMustMatch": "Los correos electrónicos deben coincidir.",
    "passwordsMustMatch": "Las contraseñas deben coincidir.",
    "errorOccurred": "Se produjo un error al enviar el formulario.",
    "tryAgain": "Vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
    "errorOccurredPDF": "Se produjo un error al cargar el PDF de la factura.",
    "password": {
      "minLength": "La contraseña debe tener al menos 8 caracteres.",
      "tooShort": "Muy corto",
      "checking": "Verificando..."
    },
    "USZipCode": "Debe ingresar un código postal de EE. UU.",
    "CAZipCode": "Debe ingresar un código postal de CA.",
    "invalidCardNumber": "Número de tarjeta no válido",
    "invalidCardType": "Tipo de tarjeta no válido",
    "invalidExpirationDate": "Fecha de vencimiento no válida",
    "invalidSecurityCode": "Código de seguridad no válido",
    "securityCodeNumericWarning": "El código de seguridad debe contener solo números.",
    "invalidUsernameWarning": "Nombre de usuario no válido. Debe contener solo letras y números.",
    "usernameMaxLengthWarning": "El nombre de usuario no puede tener más de 60 caracteres.",
    "badZip": "El código postal que se ingresó no es válido para el estado seleccionado.",
    "badPostalCode": "El código postal que se ingresó no es válido para la provincia o el territorio seleccionado.",
    "canadianAddressNeedsCad": "Las direcciones de facturación de Canadá se facturan en dólares canadienses. Para continuar, seleccione la bandera en la parte superior de la página y, luego, elija Canadá."
  },
  "invoice": {
    "communityHeader": "Sin tarjetas de crédito. Acceda gratis a myBoardmaker Community. Guarde sus datos y su progreso si decide subir de categoría a una suscripción paga. ¿Qué está esperando?",
    "trialHeader": "Sin restricciones. Sin tarjetas de crédito. Guarde sus datos y su progreso si decide convertir su versión de prueba en una suscripción paga. ¿Qué está esperando?",
    "plan": "Plan",
    "term": "Plazo",
    "price": "Precio",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Detalles de pago",
    "endingWith": "Termina en",
    "expires": "Vence",
    "orderSummary": "Resumen del pedido",
    "orderDate": "Fecha de pedido",
    "orderNumber": "Número de pedido",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Impuesto",
    "total": "Total",
    "aConfirmationEmail": "Se ha enviado un correo electrónico de confirmación del pedido a",
    "printOrderSummary": "Imprimir el resumen del pedido",
    "recurringPaymentDisclaimer": "Su pedido incluye un <strong>pago recurrente</strong> por la cantidad de <3>{{amount}}</3> que se renovará el <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Le cobraremos <strong>{{amount}}</strong> el <strong>{{date}}</strong>, cuando comience su nueva suscripción.",
    "PODisclaimer": "Su suscripción ya está activa y lista para usar. Para evitar interrupciones en su servicio, debemos recibir su pago dentro de los próximos <strong>30 días</strong>. Si el pago no se recibe antes del <4>{{date, LL}}</4>, su cuenta se convertirá en una Cuenta Comunitaria gratuita hasta que se pague el monto adeudado.",
    "purchaseOrderNumber": "Número de la orden de compra",
    "orgNotes": "Notas de organización",
    "pleaseSendACopyOfYourInvoice": "Envíe su pago o una copia de su factura a:",
    "ifYourPurchaseOrdersReady": "Si su orden de compra está lista, puede cargarla ahora.",
    "supportedFileTypes": "Tipos de archivos compatibles: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " Cuando llegue el momento, enviaremos un correo electrónico a <1>{{email}}</1> recordándole cuándo vence su próximo pago.",
    "uploadSuccessful": "¡Carga exitosa!",
    "yourAccountWillContinue": "Gracias por su pedido. Para renovar suscripciones, deberá esperar hasta 14 días mientras se procesa su pedido. Cuando se complete, recibirá un correo electrónico con la confirmación de la finalización y su factura.",
    "billing": "Dirección de facturación",
    "payment": "Método de pago",
    "ifYourPurchaseOrderIsReady": "Si su orden de compra está lista, puede cargarla ahora.",
    "PODisclaimer1": "Su suscripción ya está activa y lista para usar.",
    "PODisclaimer2": "El pago debe recibirse en un plazo de 30 días o su cuenta se convertirá en una Cuenta Comunitaria gratuita de manera automática.",
    "POStartsLaterDisclaimer": "Le enviaremos su factura el <strong>{{date}}</strong>, cuando comience su nueva suscripción. El pago vence 30 días después de esa fecha."
  },
  "legal": {
    "privacyPolicy": "Política de privacidad",
    "studentPolicy": "Política de datos de los estudiantes",
    "termsAndConditions": "Términos y condiciones",
    "termsOfService": "Términos de servicio",
    "tdTermsAndConditions": "Estoy de acuerdo con los <1>$t(legal.termsAndConditions) de Tobii Dynavox</1>",
    "contactUs": "Contáctenos"
  },
  "errors": {
    "error": "Error",
    "loadingPlans": "Cargando planes",
    "sorry": "Lo sentimos, no es su culpa..., es la nuestra.",
    "somethingWentWrong": "Hubo un problema de nuestro lado. Hemos registrado este error y le recomendamos <1>{{link}}</1> si este problema persiste.",
    "tryGoingBack": "Intente regresar o <1>{{link}}</1>",
    "downloadList": "No se pudo cargar la lista de descargas."
  },
  "404": {
    "sorry": "Lo sentimos... no se pudo encontrar esa página.",
    "oldLink": "Es posible que sea un enlace antiguo o que se haya movido.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "¡Inicie su prueba gratuita ahora!",
    "startYourFreeTrial": "¡Inicie su prueba gratuita",
    "todayWhichIncludesAccessForThirtyDays": " hoy y tendrá acceso por 30 días!"
  },
  "navigation": {
    "bmoRedirect": "Redirigiéndolo a myBoardmaker..."
  },
  "expired": {
    "expiredTrialText": "Esperamos que haya disfrutado de su vista previa sin restricciones de 30 días. Su prueba se ha convertido en un Plan Comunitario gratuito y se han guardado todos sus datos y su progreso*. Para acceder a las funciones prémium que estaban disponibles durante su prueba, solo debe subir de categoría a una suscripción mensual o anual.",
    "dataAndProgress": "* Los datos y el progreso que se guardan en las funciones prémium solo son accesibles con una suscripción paga completa."
  },
  "currencySelector": {
    "header": "Seleccione su país e idioma.",
    "disclaimer": {
      "USD": "Si su país no aparece en la lista, seleccione Estados Unidos de América."
    }
  },
  "taxExempt": {
    "us&ca": "Solo para Estados Unidos y Canadá.",
    "taxExemptionProgram": "Envíe sus documentos para la exención de los impuestos utilizando este formulario. Nos comunicaremos con usted por correo electrónico dentro de los siguientes 3 días hábiles para confirmar el estado de su exención de impuestos. Una vez que haya recibido el correo electrónico de confirmación, puede realizar su pedido sin pagar impuestos. Si realiza su pedido antes de recibir el correo electrónico de confirmación, se le cobrará un impuesto no reembolsable.",
    "taxExemptionProgramExisting": "Envíe sus documentos para la exención de los impuestos utilizando este formulario. Nos comunicaremos con usted por correo electrónico dentro de los siguientes 3 días hábiles para confirmar el estado de su exención de impuestos. Una vez que haya recibido el correo electrónico de aprobación, las futuras compras y renovaciones de suscripción no estarán sujetas a impuestos. Los impuestos que pagó sobre las compras que realizó antes de recibir el correo electrónico de confirmación de exención de impuestos no son reembolsables.",
    "yourSubmissionWasSuccessfulNew": "Su envío fue exitoso. Nuestro personal revisará su documentación. Debería recibir una notificación por correo electrónico dentro de los siguientes 3 días hábiles para confirmar que su solicitud se procesó. Una vez que se haya aceptado, podrá completar su pedido sin pagar impuestos. Mientras tanto, hemos creado una Cuenta Comunitaria gratuita para usted, para que comience a explorar todo lo que myBoardmaker tiene para ofrecer.",
    "yourSubmissionWasSuccessfulExisting": "Su envío fue exitoso. Nuestro personal revisará su documentación. Debería recibir una notificación por correo electrónico dentro de los siguientes 3 días hábiles para confirmar que su solicitud se procesó. Una vez que se haya aceptado, podrá realizar su siguiente pago sin pagar impuestos."
  },
  "modify": {
    "contactCustomerSupport": "Comuníquese con <1>{{supportLink}}</1> para modificar su suscripción",
    "billingDetails": "Modificar los detalles de facturación",
    "paymentModalHeader": "¡Actualización exitosa!",
    "paymentModalBody": "Sus cambios se reflejarán en su próximo ciclo de facturación.",
    "thankYou": "¡Gracias por su pago!",
    "daysRemaining": "días restantes",
    "dueDisclaimer": "Si el pago no se recibe dentro de los 30 días posteriores a la fecha de renovación, su cuenta se convertirá en una Cuenta Comunitaria gratuita de manera automática hasta que se pague el monto adeudado.",
    "lateDisclaimer": "Para evitar la interrupción de su suscripción, pague el monto adeudado en su totalidad. Si no se recibe el pago, su cuenta se convertirá en una Cuenta Comunitaria gratuita de manera automática hasta que se pague el monto adeudado.",
    "nextPaymentDueIn": "Su próximo pago vence en",
    "days": "días.",
    "paymentIs": "El pago venció hace",
    "daysPastDue": "días.",
    "recurringPaymentDisclaimer": "Su <1>planOrOrder</1> incluye un <strong>pago recurrente</strong> por la cantidad de <4>{{amount}}</4> que se renovará el <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Su plan incluye un <strong>pago recurrente</strong> que se renovará el <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "Puede enviar su orden de compra utilizando uno de los métodos que se describen a continuación. Comuníquese con nuestro equipo de atención al cliente para reactivar su suscripción.",
    "yourAccountHasBeenConverted": "Su cuenta paga se ha convertido en una Cuenta Comunitaria gratuita.",
    "balanceDueIn": "El saldo vence en",
    "subscriptionExpiresIn": "La suscripción expira en",
    "paymentPastDue": "Pago vencido",
    "autoRenewal": "Renovación automática",
    "turnAutoRenewOff": {
      "header": "Desactivar la renovación automática de la suscripción",
      "areYouSure": "¿Está seguro de que desea desactivar la renovación automática? Si procede, ocurrirá lo siguiente:",
      "points": [
        "Cancele su suscripción paga al final de su ciclo de facturación actual.",
        "Convierta su cuenta en un Plan Comunitario gratuito al final de su ciclo de facturación actual.",
        "Tendrá acceso a su contenido después de la conversión y podrá volver a suscribirse en cualquier momento para recuperar el acceso a las funciones prémium que incluyen las suscripciones pagas. ",
        "Si cambia de opinión antes de que finalice su suscripción actual, solo vuelva a activar la renovación automática."
      ],
      "footer": "¿Desea deshabilitar la renovación automática?"
    },
    "turnAutoRenewOn": {
      "header": "Habilitar la renovación automática de la suscripción",
      "areYouSure": "La renovación automática de la suscripción ofrece lo siguiente:",
      "points": [
        "Su suscripción está configurada para que se renueve de manera automática al final del período de suscripción actual.",
        "Pague sin problemas utilizando su método de pago almacenado.",
        "Le enviamos un recibo por correo electrónico cada vez que se renueva su suscripción.",
        "Como siempre, puede cambiar la configuración de su suscripción en cualquier momento en los detalles de Mi plan.",
        "¿Cambió de opinión? Desactive la renovación automática antes del final del último día del período de suscripción actual y no se le facturará."
      ],
      "footer": "¿Desea habilitar la renovación automática?"
    },
    "on": "Encendido",
    "off": "Apagado",
    "pending": "Pendiente",
    "plan": "Plan",
    "term": "Plazo",
    "effective": "En vigencia",
    "subscription": "Suscripción",
    "downgradeWarning": {
      "title": "Bajar la categoría de la suscripción",
      "prompt": "¿Está seguro de que desea seleccionar este plan? Si procede, ocurrirá lo siguiente:",
      "planChange": "Cambie su Plan de Profesional a Personal al final de su ciclo de facturación actual.",
      "termChange": "Reduzca el plazo de su suscripción de anual a mensual al final de su ciclo de facturación actual.",
      "changeNote": "Sus cambios se reflejarán en su próximo ciclo de facturación.",
      "termChangeMultiToYearly": "Reduzca su plazo de varios años a un plazo anual al final de su ciclo de facturación actual.",
      "termChangeMultiToMonthly": "Reduzca su plazo de varios años a un plazo mensual al final de su ciclo de facturación actual."
    },
    "futureAmendmentThankYou": "Las cancelaciones entrarán en vigencia al final del plazo actual. Una factura estará disponible una vez que estos cambios se apliquen a su cuenta. Si desea cancelar un cambio pendiente, llame a <1>Atención al cliente</1>.",
    "futureAmendmentDisclaimer": "Su plan <1>{{planName}}</1> actual  expirará el <3>{{startEndDate}}</3>. Su Nuevo <5>{{selectedPlanName}}</5>  plan comenzará el <7>{{startEndDate}}</7> y se renovará de manera automática el <9>{{term}}</9>.",
    "modificationPending": "Modificación del plan pendiente",
    "paymentDeclined": "Se rechazó la transacción de renovación de su suscripción. Modifique su método de pago antes del <1>{{date}}</1> o se cancelará su suscripción.",
    "continueSubscription": "Su suscripción terminará el <1>{{ date1 }}</1>. Si desea continuar con su suscripción por otro {{term}}, active la renovación automática antes del<5>{{ date2 }}</5> y procesaremos su pago al día siguiente.",
    "discontinuedRatePlan": "Su plan de suscripción actual ya no está disponible. Elija otra opción.",
    "cancelYourSubscription": "Si desea cancelar su suscripción y recibir un reembolso completo, debe comunicarse con <1>{{supportLink}}</1> antes de <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Modificar suscripción",
    "cancelCardText": "Puede cancelar su suscripción en cualquier momento. Pero nos encantaría que se quedara.",
    "cancelConfirmTitle": "¿Está seguro de que desea cancelar su suscripción?",
    "cancelConfirmIntro": "Su plan actual seguirá activo hasta el <strong>{{date}}</strong>. Cuando finalice su plan:",
    "cancelConsequences": [
      "Perderá el acceso a las funciones premium.",
      "Dejará de disfrutar de los beneficios exclusivos disponibles con su suscripción.",
      "Los beneficios de su suscripción terminarán cuando venza su plan actual."
    ],
    "keepSubscription": "Mantener mi suscripción",
    "confirmCancel": "No, quiero cancelar",
    "cancelledTitle": "¡Su suscripción ha sido cancelada!",
    "cancelledBody": "Su suscripción ha sido cancelada. No tendrá acceso a su cuenta premium después del {{date}}.",
    "cancelledFarewell": "¡Lamentamos que se vaya! Siempre será bienvenido de nuevo.",
    "done": "Listo",
    "cancelledNotice": "Su suscripción <strong>{{planName}}</strong> actual vencerá el <strong>{{date}}</strong>. Renueve su suscripción para seguir disfrutando de nuestras funciones premium.",
    "resubscribedNotice": "Su nueva suscripción <strong>{{planName}}</strong> comienza el <strong>{{date}}</strong>, cuando vence la actual."
  },
  "tdAccount": {
    "title": "Cuenta de Tobii Dynavox",
    "header": "¿Qué es una cuenta de inicio de sesión único (SSO) de Tobii Dynavox?",
    "body": "Su cuenta de SSO de Tobii Dynavox está compuesta por una dirección de correo electrónico y una contraseña. Esta es su única cuenta para iniciar sesión en cualquiera de nuestros sitios web o aplicaciones. Además de los beneficios de seguridad mejorados, el SSO proporciona un acceso más rápido y práctico a su contenido en todos los servicios de Tobii Dynavox.",
    "haveA": "¿Tiene una",
    "tobiiDynavoxAccount": "cuenta de Tobii Dynavox?"
  },
  "redirectPageTitle": {
    "homePage": "Página de inicio",
    "profileCreation": "Creación de perfil"
  },
  "download": {
    "downloadBoardmaker": "Descargar Boardmaker",
    "downloadBoardmakerStudentCenter": "Descargar Boardmaker Student Center",
    "downloadOtherVersions": "Descargar otras versiones",
    "downloadBoardmakerStudio": "Descargar Boardmaker Studio",
    "licenseKey": "Clave de licencia",
    "download": "Descargar",
    "licenseHelper": "Administrador de licencia",
    "discontinued": "Se suspendió el <1>{{discontinueDate}}</1>. Ver los <3>requisitos del sistema</3>.",
    "communityStartHeader": [
      "Solicite el acceso y el almacenamiento de su Cuenta Comunitaria.",
      0,
      0
    ],
    "communityStartBody": [
      "Boardmaker está diseñado para trabajar con Boardmakeronline.com, donde puede realizar copias de seguridad de sus archivos personales de Boardmaker y acceder a nuestra Comunidad global. Los miembros de la Comunidad pueden compartir sus creaciones y encontrar nuevas actividades de Boardmaker de otros usuarios. ¡Suscríbase a una Cuenta Comunitaria gratuita para obtener el acceso!",
      0,
      0
    ],
    "latestMobile": "Para obtener la mejor experiencia, intente descargar el software desde un dispositivo que cumpla con <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "requisitos del sistema",
    "viewSystemRequirements": "Consulte <1>{{guideLink}}</1> para conocer los requisitos del sistema.",
    "onThisPage": "En esta página",
    "communityStart": {
      "header": "Solicite el acceso y el almacenamiento de su Cuenta Comunitaria.",
      "body": "Boardmaker está diseñado para trabajar con myboardmaker.com. Su Cuenta Comunitaria gratuita de Boardmaker incluye:",
      "pointOne": "Almacenamiento en la nube: haga una copia de seguridad de sus archivos personales de Boardmaker y ¡acceda a ellos desde cualquier lugar!",
      "pointTwo": "Activities-to-Go: un plan de estudios temático y separado por niveles listo para imprimir y usar.",
      "pointThree": "Acceso a nuestra Comunidad global: comparta sus creaciones y encuentre nuevas actividades de Boardmaker de otros usuarios.",
      "footer": "¡Suscríbase a su Cuenta Comunitaria gratuita para obtener el acceso!"
    },
    "BoardmakerCompatible": "Este dispositivo no es compatible con el software de Boardmaker.",
    "BoardmakerStudentCenterCompatible": "Este dispositivo no es compatible con la aplicación Boardmaker Student Center.",
    "BoardmakerMobile": "Las aplicaciones Boardmaker no son compatibles con este dispositivo.",
    "mainFeatures": "Características principales",
    "compatibility": "Compatibilidad",
    "improvements": "Mejoras",
    "bugFixes": "Corrección de errores",
    "version": "Versión",
    "discontinuedSupport": "Soporte suspendido",
    "releaseDate": "Publicado el {{date}}",
    "discontinuedDate": "Suspendido el {{date}}",
    "boardmakerSummary": "Seleccione el siguiente botón para descargar la última versión del Boardmaker Editor, que se utiliza para crear y editar las actividades.  El instalador funciona para todos los tipos de cuentas e idiomas compatibles.",
    "studentCenterSummary": "Seleccione el siguiente botón para descargar la última versión del Boardmaker Student Center, que se utiliza para reproducir las actividades de Boardmaker. El instalador funciona para todos los tipos de cuentas e idiomas compatibles.",
    "boardmakerIntro": "Boardmaker 7 Editor es la principal herramienta para ayudar a educadores, terapeutas y padres a crear, editar y compartir las actividades de Boardmaker.  Apoye el aprendizaje y la comunicación en su aula, en la sala de terapia o en casa con una gran variedad de material personalizable.",
"studentCenterIntro": "Cuando se combina con determinados tipos de suscripciones a Boardmaker 7, los maestros pueden asignar actividades a los estudiantes en la aplicación Boardmaker 7 Student Center y realizar un seguimiento de su progreso.  Los estudiantes pueden utilizar la aplicación en casa o en la escuela para completar sus actividades.",
"boardmakerStudioIntro": "Boardmaker Studio permite a las personas que apoyan a estudiantes con discapacidades crear y editar actividades que los ayuden a aprender y comunicarse utilizando símbolos, texto y voz sintética y grabada.",
"mobilePlayerIntro": "Cuando se combina con determinados tipos de suscripciones a myBoardmaker, los maestros pueden asignar actividades a los estudiantes en la aplicación Boardmaker Student Center y realizar un seguimiento de su progreso.  Los estudiantes pueden utilizar la aplicación en casa o en la escuela para completar sus actividades."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "Suscripción",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "Licencia",
      "tolicenseText": "Compra única",
      "mainText": "¿Prefiere un <1>{{ toggleText }}</1> or <3>{{ helpLink }}</3>?",
      "preferencedText": "Prefiere una "
    },
    "comparison": {
      "accessTo": "Acceda a lo siguiente:",
      "title": "Necesito ayuda para elegir",
      "titleDescription": "Un vistazo rápido a las diferencias entre una suscripción a myBoardmaker y el software de Boardmaker.",
      "titles": {
        "investment": "Inversión",
        "includedSoftware": "Software incluido",
        "softwareUpdates": "Actualizaciones del software",
        "pcsSymbols": "símbolos de PCS",
        "cloudStorage": "Almacenamiento en la nube",
        "curriculum": "Plan de estudios",
        "studentManagement": "Administrador de estudiantes"
      },
      "subscription": {
        "header": "Suscripción a myBoardmaker",
        "investment": "Pago inicial bajo y opciones de pago anual o mensual",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Incluidas (2 o 3 veces al año)",
        "pcsSymbols": "Todos los símbolos, incluidos los símbolos nuevos cada 2 semanas",
        "cloudStorage": ["Administrador de actividades", "Almacén de datos"],
        "curriculum": [
          "Boardmaker Activities to Go, 10 temas con 4 unidades cada uno",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": [
          "Asigne activities\u00B9.",
          "Realice el seguimiento del rendimiento."
        ]
      },
      "license": {
        "header": "Solo el software",
        "investment": "Compra única del software",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Actualizaciones pagadas de manera periódica (cada 2 o 3 años)",
        "pcsSymbols": "Todos los símbolos disponibles en el momento del último lanzamiento (suscripción a los PCS pronto)",
        "cloudStorage": ["Administrador de actividades"],
        "curriculum": ["Boardmaker Activities to Go,1 tema con 4 unidades"],
        "studentManagement": ["Ninguno"]
      },
      "note": "Con el plan de suscripción Profesional, los usuarios pueden administrar y asignar tareas a cada estudiante de manera individual.",
      "note2": "Solo se puede acceder con el reproductor Student Center.",
      "note3": "Con el plan de suscripción Profesional, los usuarios pueden administrar y asignar tareas a cada estudiante de manera individual.",
      "localizationNoteOne": "Las aplicaciones de Boardmaker 7 están disponibles en los siguientes idiomas para los usuarios que tiene una suscripción por tiempo limitado o ilimitado (solo el software).",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Inglés (Estados Unidos)",
        "Español",
        "Alemán",
        "Sueco",
        "Finlandés",
        "Ruso",
        "Danés",
        "Noruego",
        "Francés",
        "Italiano",
        "Polaco",
        "Portugués"
      ],
      "localizationNoteTwo": "El plan de estudios y el sitio web myBoardmaker.com solo están disponibles en inglés."
    }
  },
  "systemRequirements": "Requisitos del sistema",
  "releaseNotes": "Notas de la versión",
  "operatingSystem": {
    "title": "Sistema operativo",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobile)",
    "windows": "Windows",
    "unknown": "Unknown"
  },
  "perpetual": {
    "trial": {
      "intro": "Sin tarjetas de crédito. Sin compromisos. Solo <1>{{trialLength}}</1> días consecutivos de acceso sin restricciones a nuestro último software Boardmaker. Después de descargar e instalar el software en su computadora, puede solicitar una <3>{{trialLength}}</3> clave de activación por <5> * </5> días dentro del software.",
      "footnote": "<0>*</0>Las pruebas comienzan el día en que se activa nuestro software y permanecerán activas por <2>{{trialLength}}</2> días seguidos.",
      "downloadFootnote": "<0>La v{{version}}</0> incluye las últimas funciones y correcciones. Ver los <2>requisitos del sistema</2>."
    },
    "thankyou": {
      "intro": "Busque el correo electrónico de confirmación de su pedido que contiene los enlaces de descarga de Boardmaker y su clave de activación. También le proporcionamos la información a continuación. Descargue e instale Boardmaker en su computadora, luego use la clave de activación para activar su software. Una vez activado, recibirá 1 año de actualizaciones gratuitas. <1>Asegúrese de guardar su clave de activación para su posterior uso.</1>"
    },
    "latest": "Versión más reciente",
    "legacy": "Versión heredada"
  },
  "countries": {
    "us": "Estados Unidos de América"
  },
  "currencyChange": {
    "header": "Cambio de moneda",
    "body": "En este momento, las suscripciones no se pueden comprar con la moneda del país seleccionado. Si procede, se cambiará su moneda a dólares estadounidenses (USD)."
  },
  "partner": {
    "body": "El socio elegido o el proveedor de soporte será su contacto principal para todas las preguntas y problemas técnicos que se relacionan con el producto.",
    "contactUs": "Si el país indicado no es el correcto, por favor ",
    "contactCustomerService": "comuníquese con Servicio al Cliente."
  }
}
